package app.nestbridge.domain.identity.api.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class UserDto(
    val id: String,
    val identityId: String,
    val emails: List<String> = emptyList(),
    val phoneNumbers: List<String> = emptyList(),
    val status: UserStatusDto,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)

@Serializable
enum class UserStatusDto {
    ACTIVE,
    SUSPENDED,
    DELETED,
}
